import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sidebar-close",
  "use": "icon-sidebar-close-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-sidebar-close\"><path d=\"M10.414 9l7.292-7.292A1 1 0 1016.292.292L9 7.586 1.706.292A1 1 0 00.292 1.708L7.586 9 .292 16.292a1.003 1.003 0 000 1.416 1.004 1.004 0 001.414 0L9 10.414l7.292 7.294a1.004 1.004 0 001.414 0 1 1 0 000-1.416L10.414 9z\" fill=\"#999\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol